// Nested structures keep their shape rather than being flattened into the comma-joined
// list: without this, a list of lists reads exactly like a flat list.
const formatArrayItem = (item: unknown): string => {
  if (item !== null && typeof item === 'object') return JSON.stringify(item);
  return formatOutputValue(item);
};

export const formatOutputValue = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (value === '') return '""';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.map(formatArrayItem).join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};
